<template>
  <footer id="footer">
    <div class="ns-wrap footer-grid">
      <div class="footer-brand">
        <img src="@/assets/img/logo_white.png" alt="诺思技术">
        <h3>{{ config.name }}</h3>
        <p>以人工智能与科技创意为核心，为企业交付高速、稳定、可落地的智能系统。</p>
      </div>
      <div class="footer-col">
        <h4>联系我们</h4>
        <p>电话：{{ config.phone }}</p>
        <p>传真：{{ config.tel }}</p>
        <p>邮箱：{{ config.email }}</p>
        <p>微信：{{ config.wechat }}</p>
      </div>
      <div class="footer-col">
        <h4>公司地址</h4>
        <p>{{ config.address }}</p>
        <p>7 × 24 小时为您服务</p>
      </div>
    </div>
    <div class="footer-copy">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
        Copyright © 2020 - 2024 {{ config.keepOnRecordIcp }} {{ config.name }}
      </a>
    </div>
  </footer>
</template>
<script>
import config from "@/config";
export default {
  name: "Footer",
  data() {
    return {
      config: config
    };
  }
};
</script>
<style scoped>
#footer {
  position: relative;
  padding: 72px 0 0;
  color: #b7c4d8;
  background: #0f1c33;
  border-top: 1px solid transparent;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.2fr;
  gap: 40px;
  padding-bottom: 48px;
}

.footer-brand img {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}

.footer-brand h3,
.footer-col h4 {
  margin: 0 0 14px;
  color: #fff;
  font-size: 16px;
  letter-spacing: 0.08em;
}

.footer-brand p,
.footer-col p {
  margin: 0 0 8px;
  line-height: 1.8;
  font-size: 14px;
}

.footer-copy {
  padding: 18px 24px;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-copy a {
  color: #8ea0b8;
  font-size: 13px;
}

@media (max-width: 991px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue